import EditInterviewPage from './edit-interview-page'

export default EditInterviewPage